import type { CreditModalSource } from '@wegic/price-ui';
import type { PaymentTrackingHandlers } from './tracking';
import globalEventEmitter from '@/modules/EventEmitter';
import { EVENTS } from '@/modules/EventEmitter/const';

export interface OpenCreditPurchaseModalOptions {
  defaultSelectedCredits?: number;
  trackingHandlers?: PaymentTrackingHandlers;
}

export function openCreditPurchaseModal(
  source: CreditModalSource,
  options?: OpenCreditPurchaseModalOptions,
) {
  globalEventEmitter.emit(EVENTS.OPEN_CREDIT_PURCHASE_MODAL, { source, ...options });
}

export function closeCreditPurchaseModal() {
  globalEventEmitter.emit(EVENTS.CLOSE_CREDIT_PURCHASE_MODAL);
}
